import React from 'react';

interface ExperienceDisplayProps {
  years: number;
}

const ExperienceDisplay: React.FC<ExperienceDisplayProps> = ({ years }) => {
  // Round to nearest whole year
  const roundedYears = Math.round(years);
  
  // Define text based on number of years
  let experienceText: string;
  
  if (roundedYears < 1) {
    experienceText = "New therapist";
  } else if (roundedYears === 1) {
    experienceText = "1 year";
  } else if (roundedYears < 5) {
    experienceText = `${roundedYears} years`;
  } else if (roundedYears < 10) {
    experienceText = `${roundedYears}+ years`;
  } else {
    experienceText = "10+ years";
  }
  
  return (
    <div className="inline-flex items-center bg-orange-50 text-orange-800 text-sm px-3 py-1 rounded-full">
      <span>{experienceText}</span>
    </div>
  );
};

export default ExperienceDisplay;